import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { Background } from "../../qualifiers.js";
import { auto, border, borderGradient, color, predominant, predominantGradient } from "../../qualifiers/background.js";
/**
 * Create BackgroundQualifier from IBlurredBackgroundModel
 * @param backgroundModel
 */

function createBlurredBackground(backgroundModel) {
  var brightness = backgroundModel.brightness,
      intensity = backgroundModel.intensity;
  var result = Background.blurred();

  if (brightness || brightness == 0) {
    result.brightness(brightness);
  }

  if (intensity || intensity == 0) {
    result.intensity(intensity);
  }

  return result;
}
/**
 * Create a gradientBackground from given model
 * @param background
 * @param backgroundModel
 */


function createGradientBackground(background, backgroundModel) {
  var gradientColors = backgroundModel.gradientColors,
      gradientDirection = backgroundModel.gradientDirection,
      contrast = backgroundModel.contrast,
      palette = backgroundModel.palette;

  if (contrast) {
    background.contrast();
  }

  if (palette) {
    background.palette.apply(background, _toConsumableArray(palette));
  }

  if (gradientColors) {
    background.gradientColors(+gradientColors);
  }

  if (gradientDirection) {
    background.gradientDirection(gradientDirection);
  }

  return background;
}
/**
 * Crete a background with contrast and palette from given model
 * @param background
 * @param backgroundModel
 */


function createContrastPaletteBackground(background, backgroundModel) {
  var contrast = backgroundModel.contrast,
      palette = backgroundModel.palette;

  if (contrast) {
    background.contrast();
  }

  if (palette) {
    background.palette.apply(background, _toConsumableArray(palette));
  }

  return background;
}
/**
 * Create BackgroundQualifier from IBackgroundModel
 * @param backgroundModel
 */


function createBackgroundFromModel(backgroundModel) {
  var backgroundType = backgroundModel.backgroundType;

  switch (backgroundType) {
    case 'auto':
      return auto();

    case 'blurred':
      return createBlurredBackground(backgroundModel);

    case 'border':
      return createContrastPaletteBackground(border(), backgroundModel);

    case 'borderGradient':
      return createGradientBackground(borderGradient(), backgroundModel);

    case 'predominant':
      return createContrastPaletteBackground(predominant(), backgroundModel);

    case 'predominantGradient':
      return createGradientBackground(predominantGradient(), backgroundModel);

    default:
      return color(backgroundModel.color);
  }
}

export { createBackgroundFromModel };